import { Button, Link, makeStyles, Typography } from '@material-ui/core';
import { darken } from '@material-ui/core/styles';
import type { CSSProperties } from '@material-ui/core/styles/withStyles';
import { COLORS } from '@traton/common-ui';
import { clearDeveloperAssistantConversation } from '@internal/backstage-plugin-developer-portal-support-agent';
import traton404Capy from '../../assets/traton-404-capy.svg';

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1 1 0',
    minWidth: 0,
    minHeight: '100dvh',
    boxSizing: 'border-box',
    padding: theme.spacing(8, 4),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('xs')]: {
      minHeight: 'calc(100dvh - 56px)',
      padding: theme.spacing(4, 3),
    },
  },
  heading: {
    marginTop: theme.spacing(2),
  },
  home: {
    height: theme.spacing(5),
    marginTop: theme.spacing(6),
    backgroundColor: COLORS.light.TRATON_Blue_600,
    color: COLORS.light.TRATON_White,
    '&:hover': {
      backgroundColor: darken(COLORS.light.TRATON_Blue_600, 0.2),
    },
  },
  support: {
    marginTop: theme.spacing(3),
    marginBottom: 0,
    paddingBottom: 0,
    fontWeight: theme.typography.fontWeightBold as CSSProperties['fontWeight'],
  },
  supportLink: {
    fontWeight: 'inherit',
  },
  illustration: {
    width: 891,
    maxWidth: '100%',
    margin: theme.spacing(4, 'auto', 0),
  },
  image: {
    display: 'block',
    width: 787,
    maxWidth: '100%',
    height: 'auto',
    // The supplied artwork is dark; match the white illustration in dark mode.
    filter: theme.palette.type === 'dark' ? 'brightness(0) invert(1)' : 'none',
  },
}));

export const CustomNotFoundPage = () => {
  const styles = useStyles();

  return (
    <section className={styles.root} aria-labelledby="not-found-heading">
      <Typography variant="caption" component="p">
        ERROR 404 – PAGE NOT FOUND
      </Typography>
      <Typography
        id="not-found-heading"
        variant="h3"
        component="h1"
        className={styles.heading}
      >
        Looks like Capy is hiding!
      </Typography>
      <Button
        className={styles.home}
        href="/"
        onClick={clearDeveloperAssistantConversation}
        variant="contained"
        color="primary"
      >
        Go home
      </Button>
      <Typography variant="body1" component="p" className={styles.support}>
        Or please{' '}
        <Link
          href="https://developerportal.traton.com/catalog/default/component/support-information/docs/developer-portal/#support-channels"
          underline="always"
          className={styles.supportLink}
        >
          contact support
        </Link>{' '}
        if you think this is a bug.
      </Typography>
      <div className={styles.illustration}>
        <img className={styles.image} src={traton404Capy} alt="" />
      </div>
    </section>
  );
};
